export const ThemeStyle = `
query themeStyles(
  $after: Cursor
  $before: Cursor
  $first: Int
  $last: Int
  $orderBy: ThemeStyleOrder
  $where: ThemeStyleWhereInput
) {
  themeStyles(after: $after, before: $before, first: $first, last: $last, orderBy: $orderBy, where: $where) {
    edges {
      cursor
      node {
        createdAt
        data
        default
        id
        name
        updatedAt
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
`

const ThemeStyleSelectFragmentDoc = `
    fragment ThemeStyleSelect on ThemeStyle {
  createdAt
  data
  default
  id
  name
  updatedAt
}
    `;

export const ThemeStyleUpdateDocument = `
    mutation themeStyleUpdate($id: ID!, $input: UpdateThemeStyleInput!) {
  themeStyleUpdate(id: $id, input: $input) {
    ...ThemeStyleSelect
  }
}
    ${ThemeStyleSelectFragmentDoc}`;

export const shopifyDefaultThemeDocument = `
  query shopifyDefaultTheme {
    shopifyDefaultTheme {
      name
    }
  }
`;
